import { StoreSlice } from '../types';

export declare type INullableString = string | null;
export declare type IGameItemsList = Array<any>;

// TODO: define this type
export declare type IGameConfig = {
  [key: string]: any;
};

export declare type IActiveMiss = {
  sourceId: string,
  destId: string
};

const getDefaultGameLevel = () => {
  const urlParam = new URLSearchParams(window.location.search).get('level');
  if(urlParam === null) return 0;
  return Number.isNaN(Number(urlParam)) ? urlParam : Number(urlParam);
};

const getDefaultGameCharacter = () => {
  const urlParam = new URLSearchParams(window.location.search).get('character');
  if(urlParam === null) return 0;
  return Number.isNaN(Number(urlParam)) ? urlParam : Number(urlParam);
};

export declare interface IGameSliceProps {
  score: number;
  gameLevel: number | string;
  gameCharacter: number | string;
  streakCount: number;
  movesCount: number;
  lastHit: any;
  hitsCount: number;
  hitsPercentage: number;
  progressPercentage: number;
  itemsList: IGameItemsList;
  levelConfig: IGameConfig | null,
  selectedHex: any | false,
  activeTile: any | false,
  activeMiss: IActiveMiss | null // IDs for the latest mis-selection (for animation purposes only)
  selectedToy: string;
	points: number;
  gamePlayCount: number;
}

export declare interface IGameSliceSetters {
  setScore: (v: number) => void;
  incrementScore: (v: number) => void;
  setGameLevel: (v: number | string) => void;
  setGameCharacter: (v: number | string) => void;
  setStreakCount: (v: number) => void;
  setMovesCount: (v: number) => void;
  incrementMoves: (v: number) => void;
  setHitsCount: (v: number) => void;
  incrementHits: (v: number) => void;
  setHitsPercentage: (v: number) => void;
  setProgressPercentage: (v: number) => void;
  setItemsList: (v: IGameItemsList) => void;
  setGameConfig: (v: any) => void;
  incrementStreak: (v: any) => void;
  resetStreak: (v: any) => void;
  setLastHit: (v: any) => void;
  setSelectedHex: (v: any) => void;
  setActiveTile: (v: any) => void;
  setActiveMiss: (v: IActiveMiss) => void;
  setPoints: (v: number) => void;
	setSelectedToy: (v: string) => void;
  setGamePlayCount: (v: number) => void;
}

export declare type IGameSlice = IGameSliceProps & IGameSliceSetters;

const createGameSlice: StoreSlice<IGameSliceProps, IGameSliceSetters> = (set) => ({
  score: 0,
  gameLevel: getDefaultGameLevel(),
  gameCharacter: getDefaultGameCharacter(),
  streakCount: 0,
  movesCount: 0,
  lastHit: 0,
  hitsCount: 0,
  hitsPercentage: 0,
  progressPercentage: 0,
  itemsList: [],
  levelConfig: null,
  selectedHex: false,
  activeTile: false,
  activeMiss: null,
  points: 0,
  selectedToy: '',
  gamePlayCount: 0,
  setScore: (v) => set((state) => { state.score = v; }),
  incrementScore: () => set((state) => ({ score: state.score + 1 })),
  setGameLevel: (v) => set((state) => { state.gameLevel = v; }),
  setGameCharacter: (v) => set((state) => { state.gameCharacter = v; }),
  setStreakCount: (v) => set((state) => { state.streakCount = v; }),
  setLastHit: (v) => set((state) => { state.lastHit = v; }),
  setHitsCount: (v) => set((state) => { state.hitsCount = v; }),
  setHitsPercentage: (v) => { set((state) => { state.hitsPercentage = v; }); },
  setProgressPercentage: (v) => { set((state) => { state.progressPercentage = v; }); },
  setItemsList: (v) => set((state) => { state.itemsList = v; }),
  incrementStreak: () => set((state) => ({ streakCount: state.streakCount + 1 })),
  /* eslint-disable @typescript-eslint/no-unused-vars */
  resetStreak: () => set((state) => ({ streakCount: 0 })),
  incrementHits: () => set((state) => ({ hitsCount: state.hitsCount + 1 })),
  setGamePlayCount: (v) => set((state) => { state.gamePlayCount = v; }),
  setMovesCount: (v) => set((state) => { state.movesCount = v; }),
  incrementMoves: () => set((state) => ({ movesCount: state.movesCount + 1 })),

  setGameConfig: (v) => set((state) => { state.levelConfig = v; }),
  setSelectedHex: (v) => set((state) => { state.selectedHex = v ? { ...v } : false; }),
  setActiveTile: (v) => set((state) => {
    if (v !== false) {
      state.activeTile = { ...v };
    } else {
      state.activeTile = false;
    }
  }),
  setActiveMiss: (v) => set((state) => { state.activeMiss = v; }),
  setPoints: (points: number) => set((state) => { state.points = points; }),
  setSelectedToy: (character: string) => set((state) => { state.selectedToy = character; }),
});

export default createGameSlice;
